/**
 * ObstructionDrawButtons - Shape selection buttons for drawing obstructions
 *
 * Rectangle, circle, and polygon buttons for starting obstruction drawing.
 */

import React from 'react';

type DrawMode = 'rectangle' | 'circle' | 'polygon';

interface ObstructionDrawButtonsProps {
  onStartDrawing: (mode: DrawMode) => void;
}

const DRAW_MODES: { mode: DrawMode; icon: string; label: string }[] = [
  { mode: 'rectangle', icon: '⬜', label: 'Rectangle' },
  { mode: 'circle', icon: '⭕', label: 'Circle' },
  { mode: 'polygon', icon: '🔺', label: 'Polygon' },
];

export function ObstructionDrawButtons({ onStartDrawing }: ObstructionDrawButtonsProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {DRAW_MODES.map(({ mode, icon, label }) => (
        <button
          key={mode}
          onClick={() => onStartDrawing(mode)}
          className="flex flex-col items-center justify-center gap-1 p-2 rounded-lg border-2 border-gray-300 hover:border-red-500 hover:bg-red-50 transition-colors"
        >
          <span className="text-xl">{icon}</span>
          <span className="text-xs font-semibold">{label}</span>
        </button>
      ))}
    </div>
  );
}

export default ObstructionDrawButtons;
